import { useEffect, useState } from 'react';
import usePostMessage from 'hooks/utils/usePostMessage';

const useBackNavigation = () => {
  const [isListenerAdded, setIsListenerAdded] = useState(false);
  const {
    addEventListener,
    removeEventListener,
    parsedMessage,
    processMessage
  } = usePostMessage();

  useEffect(() => {
    if (!isListenerAdded) {
      addEventListener();
      setIsListenerAdded(true);
    }

    return () => {
      removeEventListener();
      setIsListenerAdded(false);
    };
  }, []);

  useEffect(() => {
    processMessage();
  }, [parsedMessage]);
};

export default useBackNavigation;
